import { useEffect, useState } from "react"
import { StepWizard, Wizard } from "../../bpm/config/Componentes/wizard/Wizard"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BudgetReductionFactoryForm } from "./BudgetReductionFactoryForm";
import { BudgetReductionFactoryValue } from "./BudgetReductionFactoryValue";
import { BudgetReductionFactoryDocument } from "./BudgetReductionFactoryDocument";
interface MapProperties {
    FormData: Record<string, any>;
    ObjectList: object[];
    DocumentList: Record<string, any>;
}

export const BudgetReductionFactory = () => {

    const [map, setMap] = useState<MapProperties>({
        FormData: {},
        ObjectList: [],
        DocumentList: {}
    });
    const [canDiscard, setCanDiscard] = useState<boolean>(false);

    useEffect(() => {
        if (map.DocumentList.MSGList?.length > 0) {
            setCanDiscard(true)
        } else {
            setCanDiscard(false)
        }
    }, [map])

    const steps: StepWizard[] = [
        {
            keyID: "0",
            name: 'PASO 1. Formulario',
            onEvent: () => { },
            children: <BudgetReductionFactoryForm onChange={(e) => { setMap({ ...map, "FormData": e }) }} />,
            validButton: (map.FormData.FormDate && map.FormData.IDBudgetType),
            canReturn: false
        },
        {
            keyID: "1",
            name: 'PASO 2. Selección de Rubros',
            onEvent: () => { },
            children: <BudgetReductionFactoryValue formData={map.FormData} onChange={(e) => { setMap({ ...map, "ObjectList": e }) }} />,
            validButton: map.ObjectList.length > 0,
            canReturn: true
        },
        {
            keyID: "2",
            name: 'PASO 3. Crear Reducción al Presupueto Inicial',
            onEvent: () => { },
            children: <BudgetReductionFactoryDocument List={map.ObjectList} formData={map.FormData} onChange={(e) => { setMap({ ...map, "DocumentList": e }) }} />,
            validButton: false,
            canReturn: false,
            canDiscard: canDiscard
        }
    ]

    return (
        <BasicPage titulo="Generar Reducción al Presupueto Inicial">
            <Wizard title="Certificado" listStep={steps} />
        </BasicPage>
    )
}